export default __webpack_public_path__ + "static/media/manage_emp_icon.548a1584.svg";